import React from 'react';

import { Box, Icon, Image } from '@rbilabs/universal-components';
import { Typography, withTypography } from 'ucl/components/text/Typography';

import { ResizeMode } from 'components/picture/types';
import { useIsMobileBreakpoint } from 'hooks/use-media-query';
import { primitive } from 'styles/constants';

export const Container = Box.withConfig({
  paddingBottom: '$6',
  width: '100%',
  backgroundColor: primitive.$white,
  borderRadius: 'xl',
  overflow: 'hidden',
});

export const ContentContainer = Box.withConfig({
  paddingX: '$6',
});

export const Title = withTypography({
  fontFamily: 'heading',
  fontSize: 'md',
  my: '$6',
  textAlign: 'center',
});

export const ItemsSection = Box.withConfig({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
});

export const ItemsContainer = Box.withConfig({
  width: '100%',
  maxWidth: '400px',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
});

export const ItemContainer = Box.withConfig({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const ItemIconContainer = Box.withConfig({
  borderRadius: 'full',
  background: primitive.$bbqBrown,
  width: '$18',
  height: '$18',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const StyledIcon = Icon.withConfig({
  size: '$8',
  color: primitive.$meltyYellow,
});

export const ItemText = ({ ...props }: React.ComponentPropsWithoutRef<typeof Typography>) => {
  const isMobile = useIsMobileBreakpoint();

  return React.createElement(Typography, {
    variant: 'headerThree',
    fontSize: isMobile ? 'xs' : 'sm',
    style: { marginBottom: 0 },
    mt: '$4',
    textAlign: 'center',
    ...props,
  });
};

export const StyledImage = Image.withConfig(() => {
  const isMobile = useIsMobileBreakpoint();

  return {
    resizeMode: ResizeMode.cover,
    height: isMobile ? '198px' : '341px',
  };
});

export const SectionTitle = withTypography({
  variant: 'headerThree',
  fontSize: 'xl',
  my: '$6',
  textAlign: 'center',
  style: { marginBottom: 0 },
});
